import { handleActions } from 'redux-actions'
import { saveTokenDetails } from '../actions/login'

const initialState = {
  token: null,
  userId: null
}

export const loginReducer = handleActions({
  [saveTokenDetails] (prevState, action) {
    const { token, userId, accountId } = action.payload

    return {
      ...prevState,
      token,
      userId,
      accountId,
    }
  }
}, initialState)
